import { Suspense } from 'react';
import { Await, Outlet, ScrollRestoration, useLoaderData } from 'react-router';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { AuthContextProvider } from '~/contexts/auth';
import { requireOptionalUser } from '~/utils/auth';

function SpinnerFallback() {
  return (
    <div className="flex h-svh w-full items-center justify-center">
      <SpinnerPlaceholder>Logging in to SafariDB...</SpinnerPlaceholder>
    </div>
  );
}

async function loader() {
  return {
    authority: requireOptionalUser(),
  };
}

export default function Root() {
  const loaderData = useLoaderData<typeof loader>();

  return (
    <Suspense fallback={<SpinnerFallback />}>
      <Await resolve={loaderData.authority}>
        {authority => (
          <AuthContextProvider initialAuthority={authority}>
            <Outlet />
            <ScrollRestoration />
          </AuthContextProvider>
        )}
      </Await>
    </Suspense>
  );
}
Root.loader = loader;
